// extracted by mini-css-extract-plugin
module.exports = {"iegdej2":"iegdej2"};